export const DockNavBadgeDot = () => (
  <span className="bg-icon-danger absolute -right-1 -top-1 size-3 rounded-full border-2 border-tertiary" />
);
